class DomHelper {

    static closest (el, selector) {
        let matchesFn;

        // find vendor prefix
        ['matches','webkitMatchesSelector','mozMatchesSelector','msMatchesSelector','oMatchesSelector'].some(function(fn) {
            if (typeof document.body[fn] === 'function') {
                matchesFn = fn;
                return true;
            }
            return false;
        });

        let parent;

        // traverse parents
        while (el) {
            parent = el.parentElement;
            if (parent && parent[matchesFn](selector)) {
                return parent;
            }
            el = parent;
        }

        return null;
    }

    static elementExists (elem) {
        return elem !== undefined && elem !== 'undefined' && elem !== null;
    }

    static enablePageScroll (classname) {
        let wrapper = document.getElementById('overflow-wrapper'),
          top = parseInt(wrapper.style.top, 10) * -1;

        if(wrapper.classList.contains(classname)) {
            wrapper.classList.remove(classname);
            wrapper.style.top = '';

            window.scrollTo(0, parseInt(top, 10));
        }
    }

    static elementInViewport (el) {
        let top = el.offsetTop;
        let left = el.offsetLeft;
        let width = el.offsetWidth;
        let height = el.offsetHeight;

        while(el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
            left += el.offsetLeft;
        }

        return (
          top < (window.pageYOffset + window.innerHeight) &&
          left < (window.pageXOffset + window.innerWidth) &&
          (top + height) > window.pageYOffset &&
          (left + width) > window.pageXOffset
        );
    }

    static getWindowInnerWidth () {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }

    static maxValueInArray (array) {
        return Math.max.apply(Math, array);
    }

    static isTouchDevice () {
        return ('ontouchstart' in document.documentElement);
    }

    static stopPageScroll (classname) {
        let wrapper = document.getElementById('overflow-wrapper');

        if(!wrapper.classList.contains(classname)) {
            wrapper.style.top = '-' + window.scrollY + 'px';
            wrapper.classList.add(classname);
        }
    }
}


class Cookies {
  static get (cname, dflt) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }

      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }

    if(typeof dflt === 'undefined') {
      dflt = null;
    }

    return dflt;
  }

  static has (cname) {
    return Cookies.get(cname, null) !== null;
  }

  static set (cname, cvalue, exdays) {
    if(typeof exdays == 'undefined') {
      exdays = 3650; // 10 Jahre
    }
    let d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
}


export {
    DomHelper,
  Cookies
};
